"use strict;"

var _ = require('lodash');
exports["alert"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<div class="alert alert-' + ((__t = (type)) == null ? '' : __t) + '" role="alert">\n  ' + ((__t = (message)) == null ? '' : __t) + '\n</div>';

  }
  return __p
};
exports["auth.css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += 'body {\n\tbackground-color: ' + ((__t = (background_color)) == null ? '' : __t) + '\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' {\n\tmax-width: 980px;\n\tmargin: 50px auto;\n\ttext-align: center;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .text {\n\tmargin: 30px 0;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' h1 {\n\tcolor: ' + ((__t = (label_text_color)) == null ? '' : __t) + ';\n\tmargin: 30px auto;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' p {\n\tcolor: ' + ((__t = (label_text_color)) == null ? '' : __t) + ';\n\tfont-size: 26px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' p:nth-child(3) {\n\tfont-size: 20px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .brand-image {\n\tmax-width: 300px;\n\tmargin: 0px auto 40px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .brand-image img {\n\tmax-height: 350px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .brand-image img {\n\tmargin: auto;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .facebook {\n\tcolor: #ffffff;\n\tbackground-color: #3b5998;\n\tfont-size: 26px;\n\tpadding: 15px 40px;\n\t-webkit-border-radius: 10px;\n\t-moz-border-radius: 10px;\n\t-ms-border-radius: 10px;\n\tborder-radius: 10px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .facebook img {\n\tdisplay: inline;\n\twidth: 35px;\n\tpadding-right: 8px;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .no-fblogin {\n    margin-top: 20px;\n}\n' + ((__t = (namespace)) == null ? '' : __t) + ' .no-fblogin a {\n  color: #353336;\n  text-decoration: underline;\n}';

  }
  return __p
};
exports["auth"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += '<div class="text">\n\t<h1>' + ((__t = (headline)) == null ? '' : __t) + '</h1>\n\t<p>' + ((__t = (paragraph1)) == null ? '' : __t) + '</p>\n\t<p>' + ((__t = (paragraph2)) == null ? '' : __t) + '</p>\n</div>\n<div class="brand-image">\n\t';
    if (optional_image) {;
      __p += '\n\t\t<img src="' + ((__t = (optional_image)) == null ? '' : __t) + '" />\n\t';
    };
    __p += '\n</div>\n<button class="facebook">\n\t<img src="//ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678194.5674.png">\n\t' + ((__t = (login_text)) == null ? '' : __t) + '\n</button>\n<div class="no-fblogin">\n\t<a href="#" class="no-fblogin-link">Ich habe kein facebook-Konto</a>\n</div>';

  }
  return __p
};
exports["banner.css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += ((__t = (namespace)) == null ? '' : __t) + ' .banner-image {\n\tbackground: url(' + ((__t = (banner_image_desktop)) == null ? '' : __t) + ');\n\tbackground-size: 100%;\n}\n\n@media (max-width: 400px) {\n\t' + ((__t = (namespace)) == null ? '' : __t) + ' .banner-image {\n\t\tbackground: url(' + ((__t = (banner_image_mobile)) == null ? '' : __t) + ');\n\t\tbackground-size: 100% 100%;\n\t}\n\n\t' + ((__t = (namespace)) == null ? '' : __t) + ' .banner-image img {\n\t\tmin-height: 145px;\n\t}\n\n\t' + ((__t = (namespace)) == null ? '' : __t) + ' .banner-image .logo-clicker{\n\t\twidth: 100px;\n\t\theight: 45px;\n\t}\n}';

  }
  return __p
};
exports["banner"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += '<div class="banner-image">\n\t<img src="' + ((__t = (banner_image_desktop)) == null ? '' : __t) + '">\n\t<a href="' + ((__t = (logo_url)) == null ? '' : __t) + '" target="_blank" class="logo-clicker"></a>\n</div>\n';
    if (windowStatus != 0) {;
      __p += '\n\t<div class="row banner-info">\n\t\t<h2>' + ((__t = (headline)) == null ? '' : __t) + '</h2>\n\t\t<p>' + ((__t = (paragraph)) == null ? '' : __t) + '</p>\n\t</div>\n';
    };


  }
  return __p
};
exports["css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {


    if (document.createStyleSheet && font_import !== '') {
      document.createStyleSheet(font_import);
    } else {;
      __p += '\n@import url(' + ((__t = (font_import)) == null ? '' : __t) + ');\n';

    };
    __p += '\n\nbody, html {\n\tfont-family: ' + ((__t = (font_family)) == null ? '' : __t) + ';\n\tpadding: 0;\n\tmax-width: 970px;\n\tmargin: 0 auto;\n}';

  }
  return __p
};
exports["error"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<h1>' + ((__t = (headline1)) == null ? '' : __t) + '</h1>\n<p>' + ((__t = (paragraph1)) == null ? '' : __t) + '</p>\n<a href="#' + ((__t = (button.route)) == null ? '' : __t) + '" class="btn btn-close' + ((__t = ((button.display === 'true') ? '' : ' hidden')) == null ? '' : __t) + '">' + ((__t = (button.text)) == null ? '' : __t) + '</a>';

  }
  return __p
};
exports["footer"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<footer>\n\t<p>' + ((__t = (footer_text)) == null ? '' : __t) + '</p>\n\t<img src="' + ((__t = (footer_image_desktop)) == null ? '' : __t) + '">\n</footer>';

  }
  return __p
};
exports["form.css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += ((__t = (namespace)) == null ? '' : __t) + ' form {\n    background-color: ' + ((__t = (background_color)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' label {\n    color: ' + ((__t = (label_text_color)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' a {\n    color: ' + ((__t = (link_text_color)) == null ? '' : __t) + ';\n    text-decoration: none;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .additional_info {\n    color: ' + ((__t = (additional_info_color)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .error-message {\n    color: ' + ((__t = (error_text_color)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .separator {\n    border-top: ' + ((__t = (separator_border_style)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .separator h3 {\n\tcolor: ' + ((__t = (separator_text_color)) == null ? '' : __t) + ';\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' button.btn,\n' + ((__t = (namespace)) == null ? '' : __t) + ' button.btn:active,\n' + ((__t = (namespace)) == null ? '' : __t) + ' .file-combo .btn-file {\n    color: ' + ((__t = (button_text_color)) == null ? '' : __t) + ';\n    border: ' + ((__t = (button_border_style)) == null ? '' : __t) + ';\n    ';
    if (button_background_color !== '' && button_background_gradient_color === '') {;
      __p += '\n    background-color: ' + ((__t = (button_background_color)) == null ? '' : __t) + ';\n    background: ' + ((__t = (button_background_color)) == null ? '' : __t) + ';\n    background-image: none;\n    ';
    } else if (button_background_color !== '' && button_background_gradient_color !== '') {;
      __p += '\n\tbackground: ' + ((__t = (button_background_color)) == null ? '' : __t) + '; /* Old browsers */\n\tbackground: -moz-linear-gradient(' + ((__t = (button_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '); /* FF3.6+ */\n\tbackground: -webkit-linear-gradient(' + ((__t = (button_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '); /* Chrome10+,Safari5.1+ */\n\tbackground: -o-linear-gradient(' + ((__t = (button_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '); /* Opera 11.10+ */\n\tbackground: -ms-linear-gradient(' + ((__t = (button_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '); /* IE10+ */\n\tbackground: linear-gradient(' + ((__t = (button_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '); /* W3C */\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'' + ((__t = (button_background_color)) == null ? '' : __t) + '\', endColorstr=\'' + ((__t = (button_background_gradient_color)) == null ? '' : __t) + '\',GradientType=0 ); /* IE6-9 */\n    ';
    };
    __p += '\n\n    transition: background-color .3s;\n    transition: background .3s;\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' button.btn:hover,\n' + ((__t = (namespace)) == null ? '' : __t) + ' .file-combo .btn-file:hover {\n    color: ' + ((__t = (button_hover_text_color)) == null ? '' : __t) + ';\n\n    ';
    if (button_hover_background_color !== '' && button_hover_background_gradient_color === '') {;
      __p += '\n    background-color: ' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ';\n    background: ' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ';\n    background-image: none;\n    ';
    } else if (button_hover_background_color !== '' && button_hover_background_gradient_color !== '') {;
      __p += '\n\tbackground: ' + ((__t = (button_hover_background_color)) == null ? '' : __t) + '; /* Old browsers */\n\tbackground: -moz-linear-gradient(' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '); /* FF3.6+ */\n\tbackground: -webkit-linear-gradient(' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '); /* Chrome10+,Safari5.1+ */\n\tbackground: -o-linear-gradient(' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '); /* Opera 11.10+ */\n\tbackground: -ms-linear-gradient(' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '); /* IE10+ */\n\tbackground: linear-gradient(' + ((__t = (button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '); /* W3C */\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'' + ((__t = (button_hover_background_color)) == null ? '' : __t) + '\', endColorstr=\'' + ((__t = (button_hover_background_gradient_color)) == null ? '' : __t) + '\',GradientType=0 ); /* IE6-9 */\n    ';
    };
    __p += '\n\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .form-group a.reset {\n    color: ' + ((__t = (reset_button_text_color)) == null ? '' : __t) + ';\n    text-decoration: underline;\n\n    ';
    if (reset_button_background_color !== '' && reset_button_background_gradient_color === '') {;
      __p += '\n    background-color: ' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ';\n    background: ' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ';\n    background-image: none;\n    ';
    } else if (reset_button_background_color !== '' && reset_button_background_gradient_color !== '') {;
      __p += '\n\tbackground: ' + ((__t = (reset_button_background_color)) == null ? '' : __t) + '; /* Old browsers */\n\tbackground: -moz-linear-gradient(' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '); /* FF3.6+ */\n\tbackground: -webkit-linear-gradient(' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '); /* Chrome10+,Safari5.1+ */\n\tbackground: -o-linear-gradient(' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '); /* Opera 11.10+ */\n\tbackground: -ms-linear-gradient(' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '); /* IE10+ */\n\tbackground: linear-gradient(' + ((__t = (reset_button_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '); /* W3C */\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'' + ((__t = (reset_button_background_color)) == null ? '' : __t) + '\', endColorstr=\'' + ((__t = (reset_button_background_gradient_color)) == null ? '' : __t) + '\',GradientType=0 ); /* IE6-9 */\n    ';
    };
    __p += '\n}\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .form-group a.reset:hover {\n    color: ' + ((__t = (reset_button_hover_text_color)) == null ? '' : __t) + ';\n\n    ';
    if (reset_button_hover_background_color !== '' && reset_button_hover_background_gradient_color === '') {;
      __p += '\n    background-color: ' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ';\n    background: ' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ';\n    background-image: none;\n    ';
    } else if (reset_button_hover_background_color !== '' && reset_button_hover_background_gradient_color !== '') {;
      __p += '\n\tbackground: ' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + '; /* Old browsers */\n\tbackground: -moz-linear-gradient(' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '); /* FF3.6+ */\n\tbackground: -webkit-linear-gradient(' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '); /* Chrome10+,Safari5.1+ */\n\tbackground: -o-linear-gradient(' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '); /* Opera 11.10+ */\n\tbackground: -ms-linear-gradient(' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '); /* IE10+ */\n\tbackground: linear-gradient(' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + ', ' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '); /* W3C */\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'' + ((__t = (reset_button_hover_background_color)) == null ? '' : __t) + '\', endColorstr=\'' + ((__t = (reset_button_hover_background_gradient_color)) == null ? '' : __t) + '\',GradientType=0 ); /* IE6-9 */\n    ';
    };
    __p += '\n}\n\n\n' + ((__t = (namespace)) == null ? '' : __t) + ' .checkbox a {\n    color: ' + ((__t = (reset_button_text_color)) == null ? '' : __t) + ';\n    text-decoration: underline;\n}';

  }
  return __p
};
exports["form"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += '<form action="" method="post" class="uploader-form">\n\t<div class="form-wrapper container-fluid">\n    ';
    var slots = 2;;
    __p += '\n    ';
    var tabindex = 1;;
    __p += '\n\t\t';
    _.each(fields, function (field, index) {;
      __p += '\n      ';
      if (field.column === '') field.column = 'full';;
      __p += '\n      ';
      if (field.column.indexOf('full') !== -1 && index > 0 && slots < 2) {;
        __p += '</div>';
      };
      __p += '\n      ';
      if (field.column.indexOf('full') !== -1) {
        slots = 2;
      };
      __p += '\n      ';
      if (slots === 2) {;
        __p += '<div class="row">';
      };
      __p += '\n\n\n      ';
      if (field.type === "radio") {;
        __p += '\n          <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n            <div class="form-group">\n              <label class="radio-question">\n                ' + ((__t = (field.label)) == null ? '' : __t) + '\n              </label>\n              <div class="radio">\n                ';
        for (var i = 0; i < field.options_list.length; i++) {;
          __p += '\n                  ';
          var option = field.options_list[i];;
          __p += '\n                  <label class="radio-inline">\n                    <input type="radio" value="' + ((__t = (option)) == null ? '' : __t) + '" name="' + ((__t = (field.id)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '">\n                    ' + ((__t = (option)) == null ? '' : __t) + '\n                  </label>\n                ';
        };
        __p += '\n              </div>\n            </div>\n          </div>\n      ';
      } else if (field.type === "checkbox") {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group">\n            <div class="checkbox">\n                <label class="checkbox-inline">\n                  <input type="checkbox" value="true" name="' + ((__t = (field.id)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '"\n                  ';
        if (field.id == "eighteen_or_older") {;
          __p += '\n                    ' + ((__t = ((useFB && user && (user.age_range === "18-20" || user.age_range === "21+")) ? "checked" : "")) == null ? '' : __t) + '\n                  ';
        };
        __p += '\n                  />\n                  ' + ((__t = (field.label)) == null ? '' : __t) + '\n                </label>\n            </div>\n          </div>\n        </div>\n      ';
      } else if (field.type === "file") {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n\n          <div class="form-group">\n            <label for="' + ((__t = (field.id)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</label>\n\n            <div class="input-group file-combo ' + ((__t = (field.class)) == null ? '' : __t) + '">\n              <span class="input-group-btn">\n                  <span class="btn btn-sm btn-default btn-file ">\n                  <span class="browse">' + ((__t = ((field.hasOwnProperty('secondary_label')) ? field.secondary_label : 'Select')) == null ? '' : __t) + '</span>\n                  <input class="uploader-file-input" type="' + __e(field.type) + '" name="' + ((__t = (field.id)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '"/><!-- No white space in between please\n               --></span><!-- No white space in between please\n          --></span><!-- No white space in between please\n          --><span class="file-combo-text"><input type="text" name="' + ((__t = (field.id)) == null ? '' : __t) + '_filename" class="file-combo-name" disabled="disabled"></span>\n              <span class="btn btn-close"></span>\n            </div>\n\n            <p class="additional_info">' + ((__t = (field.additional_info)) == null ? '' : __t) + '</p>\n\n          </div>\n        </div>\n      ';
      } else if (field.type === 'textarea') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group ';
        if (field.display_counter === 'true') {;
          __p += 'has-counter';
        };
        __p += '">\n            <label for="' + ((__t = (field.id)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</label>\n\n            <div class="textarea ';
        if (field.display_counter === 'true') {;
          __p += 'input-group';
        };
        __p += '">\n              <textarea type="' + __e(field.type) + '" class="' + ((__t = (field.class)) == null ? '' : __t) + ' form-control" placeholder="' + ((__t = (field.placeholder)) == null ? '' : __t) + '" name="' + ((__t = (field.id)) == null ? '' : __t) + '" maxlength="' + ((__t = (field.max_length)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '"></textarea>\n              ';
        if (field.display_counter === 'true') {;
          __p += '\n              <span class="input-group-counter input-group-addon">' + ((__t = (field.max_length)) == null ? '' : __t) + '</span>\n              ';
        };
        __p += '\n            </div>\n\n            <p class="additional_info">' + ((__t = (field.additional_info)) == null ? '' : __t) + '</p>\n          </div>\n        </div>\n      ';
      } else if (field.type === 'submit') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group">\n            <button type="submit" name="' + ((__t = (field.id)) == null ? '' : __t) + '" class="' + ((__t = (field.class)) == null ? '' : __t) + ' btn btn-large submit" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</button>\n          </div>\n        </div>\n      ';
      } else if (field.type === 'number') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group">\n          <label for="' + ((__t = (field.id)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</label>\n            <input type="' + ((__t = (field.type)) == null ? '' : __t) + '" name="' + ((__t = (field.id)) == null ? '' : __t) + '" class="' + ((__t = (field.class)) == null ? '' : __t) + ' form-control" min="' + ((__t = (field.min_length)) == null ? '' : __t) + '" max="' + ((__t = (field.max_length)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '" maxlength="3" />\n          </div>\n        </div>\n      ';
      } else if (field.type === 'reset') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group">\n            <a href="#" name="' + ((__t = (field.id)) == null ? '' : __t) + '" class="reset ' + ((__t = (field.class)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</a>\n          </div>\n        </div>\n      ';
      } else if (field.type === 'select') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group">\n            <label for="' + ((__t = (field.id)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</label>\n\n            <select class="' + ((__t = (field.class)) == null ? '' : __t) + ' form-control" name="' + ((__t = (field.id)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '">\n              <option value=""></option>\n              ';
        _.each(field.options_list, function (item, index) {;
          __p += '\n                <option value="' + ((__t = (_.escape(item))) == null ? '' : __t) + '"\n                ';
          if (useFB && user && user.gender) {;
            __p += '\n                  ' + ((__t = (((user.gender === "F" && item === "Weiblich") || (user.gender === "M" && item === "Männlich")) ? "selected" : "")) == null ? '' : __t) + '\n                ';
          };
          __p += '\n                >' + ((__t = (item)) == null ? '' : __t) + '</option>\n              ';
        });
        __p += '\n            </select>\n\n          </div>\n          \n          <p class="additional_info">' + ((__t = (field.additional_info)) == null ? '' : __t) + '</p>\n        </div>\n      ';
      } else if (field.type === 'section') {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + ' separator">\n          <h3>' + ((__t = (field.label)) == null ? '' : __t) + '</h3>\n        </div>\n\t\t\t';
      } else {;
        __p += '\n        <div class="' + ((__t = (field.column)) == null ? '' : __t) + '">\n          <div class="form-group ';
        if (field.display_counter === 'true') {;
          __p += 'has-counter';
        };
        __p += '">\n            <label for="' + ((__t = (field.id)) == null ? '' : __t) + '">' + ((__t = (field.label)) == null ? '' : __t) + '</label>\n\n            <div class="';
        if (field.display_counter === 'true') {;
          __p += 'input-group';
        };
        __p += '">\n              \n              <input type="' + __e(field.type) + '" placeholder="' + ((__t = (field.placeholder)) == null ? '' : __t) + '" class="' + ((__t = (field.class)) == null ? '' : __t) + ' form-control" name="' + ((__t = (field.id)) == null ? '' : __t) + '" maxlength="' + ((__t = (field.max_length)) == null ? '' : __t) + '" tabindex="' + ((__t = (tabindex++)) == null ? '' : __t) + '"\n\n              ';
        if (field.id == "email") {;
          __p += '\n                value="' + ((__t = ((useFB && user && user.email) ? user.email : "")) == null ? '' : __t) + '"\n              ';
        } else if (field.id == "first_name") {;
          __p += '\n                value="' + ((__t = ((useFB && user && user.first_name) ? user.first_name : "")) == null ? '' : __t) + '"\n              ';
        } else if (field.id == "last_name") {;
          __p += '\n                value="' + ((__t = ((useFB && user && user.last_name) ? user.last_name : "")) == null ? '' : __t) + '"\n              ';
        };
        __p += '\n\n              />\n\n              ';
        if (field.display_counter === 'true') {;
          __p += '\n              <span class="input-group-counter input-group-addon">' + ((__t = (field.max_length)) == null ? '' : __t) + '</span>\n              ';
        };
        __p += '\n            </div>\n            <p class="additional_info">' + ((__t = (field.additional_info)) == null ? '' : __t) + '</p>\n          </div>\n        </div>\n\t\t\t';
      };
      __p += '\n\n      ';
      if (field.column.indexOf('full') !== -1) {
        slots = 0;
      };
      __p += '\n      ';
      if (field.column.indexOf('half') !== -1) {
        slots--;
      };
      __p += '\n      ';
      if (slots === 0) {
        slots = 2;;
        __p += '</div>';
      };
      __p += '\n\t\t';
    });
    __p += '\n\t</div>\n</form>\n';

  }
  return __p
};
exports["loading"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<h1>' + ((__t = (headline1)) == null ? '' : __t) + '</h1>\n<p>' + ((__t = (paragraph1)) == null ? '' : __t) + '</p>\n<div>\n  <p class="loading-label">' + ((__t = (headline2)) == null ? '' : __t) + '</p>\n\n<div class="progress progress-striped active">\n  <div class="progress-bar" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100" style="width: 0%">\n  </div>\n</div>\n\n</div>';

  }
  return __p
};
exports["message.css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += ((__t = (namespace)) == null ? '' : __t) + ' h1 {\n    color: ' + ((__t = (headline1_color)) == null ? '' : __t) + ';\n}\n' + ((__t = (namespace)) == null ? '' : __t) + ' h2 {\n    color: ' + ((__t = (headline1_color)) == null ? '' : __t) + ';\n}\n' + ((__t = (namespace)) == null ? '' : __t) + ' p {\n    color: ' + ((__t = (paragraph_color)) == null ? '' : __t) + ';\n}\n';

  }
  return __p
};
exports["message"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += '<div class="container-fluid">\n\n';
    if (headline1) {;
      __p += '<h1>' + ((__t = (headline1)) == null ? '' : __t) + '</h1>';
    };
    __p += '\n';
    if (headline1) {;
      __p += '<h2>' + ((__t = (headline2)) == null ? '' : __t) + '</h2>';
    };
    __p += '\n\n\n';
    if (paragraph1) {;
      __p += '<p>' + ((__t = (paragraph1)) == null ? '' : __t) + '</p>';
    };
    __p += '\n';
    if (paragraph2) {;
      __p += '<p>' + ((__t = (paragraph2)) == null ? '' : __t) + '</p>';
    };
    __p += '\n';
    if (paragraph3) {;
      __p += '<p>' + ((__t = (paragraph3)) == null ? '' : __t) + '</p>';
    };
    __p += '\n\n</div>';

  }
  return __p
};
exports["modal"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<div class="modal-window">\n    <div class="modal-wrapper">\n        <div class="modal-layout">\n            <div class="modal-content">\n\n            </div>\n        </div>\n    </div>\n</div>';

  }
  return __p
};
exports["terms"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += '<div class="document-wid">\n\t' + ((__t = (document)) == null ? '' : __t) + '\n</div>';

  }
  return __p
};
exports["window.css"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape;
  with(obj) {
    __p += ((__t = (namespace)) == null ? '' : __t) + ' h1 {\n    color: ' + ((__t = (headline1_color)) == null ? '' : __t) + ';\n}\n' + ((__t = (namespace)) == null ? '' : __t) + ' h2 {\n    color: ' + ((__t = (headline1_color)) == null ? '' : __t) + ';\n}\n' + ((__t = (namespace)) == null ? '' : __t) + ' p {\n    color: ' + ((__t = (paragraph_color)) == null ? '' : __t) + ';\n}';

  }
  return __p
};
exports["window"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {
    __p += '<div class="text">\n';
    if (headline1) {;
      __p += '<h1>' + ((__t = (headline1)) == null ? '' : __t) + '</h1>';
    };
    __p += '\n';
    if (headline1) {;
      __p += '<h2>' + ((__t = (headline2)) == null ? '' : __t) + '</h2>';
    };
    __p += '\n\n\n';
    if (paragraph1) {;
      __p += '<p>' + ((__t = (paragraph1)) == null ? '' : __t) + '</p>';
    };
    __p += '\n';
    if (paragraph2) {;
      __p += '<p>' + ((__t = (paragraph2)) == null ? '' : __t) + '</p>';
    };
    __p += '\n';
    if (paragraph3) {;
      __p += '<p>' + ((__t = (paragraph3)) == null ? '' : __t) + '</p>';
    };
    __p += '\n</div>';

  }
  return __p
};